var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8116 6.2915C17.5274 6.29553 19.3182 6.31295 21.2216 6.38936L21.8972 6.41884C23.8127 6.50865 25.7268 6.66414 26.6772 6.92821C27.9439 7.28476 28.9385 8.32226 29.2749 9.63856C29.8111 11.7296 29.8781 15.8072 29.8862 16.7951L29.8875 16.9989V17.2321C29.8781 18.22 29.8111 22.2989 29.2749 24.3887C28.9345 25.709 27.9385 26.7478 26.6772 27.099C25.7268 27.3631 23.8127 27.5186 21.8972 27.6084L21.2216 27.6392C19.3182 27.7143 17.5274 27.7331 16.8116 27.7357L16.4966 27.7371H16.1548C14.6401 27.7277 8.3052 27.6593 6.28919 27.099C5.02383 26.7425 4.02789 25.705 3.69144 24.3887C3.15526 22.2976 3.08824 18.22 3.0802 17.2321V16.7951C3.08824 15.8072 3.15526 11.7283 3.69144 9.63856C4.03191 8.31824 5.02785 7.2794 6.29054 6.92955C8.3052 6.36791 14.6414 6.29955 16.1561 6.2915H16.8116ZM13.8023 12.3234V21.7065L21.8449 17.015L13.8023 12.3234Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bfcc4d20848741994fdbd5069e2d9685.svg";
export { ForwardRef as ReactComponent };